module.exports = __webpack_public_path__ + "static/media/guest.edefcdff.png";